import * as _ from 'lodash';
import * as toastr from 'toastr';

import * as UserManagement from '../../';
import * as Common from '../../../../Common/modules';
import * as Models from '../../../../Models';
import * as Services from '../../../../Services';

export interface IGroupSearchCtrlScope {
    groupSearchCtrl: GroupSearchCtrl;
}

export class GroupSearchCtrl {
    private showLogging: boolean = false;
    private roleList: Models.Auth.RoleList.RoleList = new Models.Auth.RoleList.RoleList();
    private groups: Models.GroupModel.IGroupModel[];
    public groupsHash: {};
    public groupToAdd: Models.GroupModel.GroupModel;
    private allPartners: Models.PartnerModel.PartnerModel[] = [];

    public static $inject = [
        "$scope",
        "$state",
        "GroupRetrievalService",
        "GroupSaveService",
        "PartnerRetrievalService",
        "UserService",
        "igs.messageBox",
    ];

    constructor(
        $scope: IGroupSearchCtrlScope,
        private $state: angular.ui.IStateService,
        private groupRetrievalService: UserManagement.services.GroupRetrievalService.IGroupRetrievalService,
        private groupSaveService: UserManagement.services.GroupSaveService.GroupSaveService,
        private partnerRetrievalService: UserManagement.services.PartnerRetrievalService.IPartnerRetrievalService,
        private userService: Services.UserService.IUserService,
        private messageBox: any,
    ) {
        $scope.groupSearchCtrl = this;
        // Only user admins can manage groups
        this.userService.isUserInRole(this.roleList.manageUsersAdmin).then((response) => {
            if (response === false) {
                this.$state.go("main.customersearchv2");
            }
        });

        this.getAndSetGroups();
        this.getAllPartners();
    }

    public getAndSetGroups(): ng.IPromise<void> {
        if (this.showLogging) {
            console.log("getting all groups...");
        }
        return this.groupRetrievalService.getAllGroupSummaries().then((groups: Models.GroupModel.IGroupModel[]) => {
            this.groups = _.sortBy(groups, "name");
            this.groupsHash = _.keyBy(groups, 'groupId')
        });
    }

    private getAllPartners(): ng.IPromise<void> {
        if (this.showLogging) {
            console.log("getting all partners...");
        }

        return this.partnerRetrievalService.getPartners().then((partners: Models.PartnerModel.IPartnerModel[]) => {
            this.allPartners = _.sortBy(partners, "name");
        });
    }

    public addGroup = () => {
        if (this.showLogging) {
            console.log("adding group...");
        }
        if (
            !this.groupToAdd ||
            !this.groupToAdd ||
            !this.groupToAdd.name ||
            !this.groupToAdd.partner ||
            this.groupToAdd.name.length <= 0
        ) {
            toastr.error("Please enter a valid group name and partner", "Error");
            return;
        }

        if (this.checkIfGroupExists()) {
            toastr.error("Duplicate Group Name on Partner", "Error");
            return;
        }

        var openBox = this.messageBox.open("Create Group", "Are you sure you want to create this group?", [
            { label: "OK", cssClass: "btn-success", result: true },
            { label: "Cancel", cssClass: "btn-cancel", result: false },
        ]);

        openBox.then((result: boolean) => {
            if (result) {
                var group = new Models.GroupModel.GroupModel(
                    this.groupToAdd.name,
                    this.groupToAdd.partner,
                    this.groupToAdd.rejectionEmailDistro,
                    this.groupToAdd.cancellationEmailDistro
                );
                this.groupSaveService.saveGroup(group).then(
                    () => {
                        this.$state.reload();
                        toastr.success("Group Added", "Success");
                    },
                    () => {
                        toastr.error("There was a problem saving the group", "Error");
                    },
                );
            }
        });
    };

    private checkIfGroupExists = () => {
        if (this.showLogging) {
            console.log("checking if group exists...");
        }
        var groupExists = false;
        _.forEach(this.groups, (group) => {
            if (
                group.name.toLowerCase() === this.groupToAdd.name.toLowerCase() &&
                this.groupToAdd.partner.code.toUpperCase() === group.partner.code.toUpperCase()
            ) {
                groupExists = true;
                return groupExists;
            }
        });
        return groupExists;
    };
}
